import React from 'react'
import "./footer.css"
import Fact from '../../components/Fact/Fact'


const Footer = ({currentPlanetData}:{currentPlanetData:any}) => {

  return currentPlanetData && (
    <footer id='footer'>
      <Fact headline='rotation' value={currentPlanetData[0]?.rotation}/>
      <Fact headline='revolution' value={currentPlanetData[0]?.revolution}/>
      <Fact headline='radius' value={currentPlanetData[0]?.radius}/>
      <Fact headline='temperature' value={currentPlanetData[0]?.temperature}/>
    </footer>
  )
}

export default Footer
